import React from 'react';

import martrimonyLogo from '@/common/assets/images/LogoHeaer.png';
import styles from './index.module.less';

const Cookie = () => {
  return (
    <div
      className={styles.maincontainer}
      // style={{
      //   paddingTop: '0px',
      //   paddingLeft: '0px',
      //   paddingRight: '0px',
      //   paddingBottom: '0px'
      // }}
    >
      <div className={styles.headerload}>
        <img
          src={martrimonyLogo}
          alt="matrimony logo"
          className={styles.logostyles}
        />
      </div>
      <div
        className={styles.cookieRow}
        // style={{
        //   display: 'flex',
        //   flexDirection: 'row',
        //   gap: '16px',
        //   marginTop: '8px',
        //   marginRight: '8px'
        // }}
      >
        <div className={styles.cookie}>
          <div className={styles.bgleft}></div>
        </div>
        <div className={styles.cookiecontainer}>
          <div className={styles.cookie_right}>
            <div className={styles.listview}>
              <h4>Cookie Policy</h4>

              <h6>Introduction</h6>

              <p>
                Welcome to Elite Samskurti (&quot;we,&quot; &quot;our,&quot;
                &quot;us,&quot; or &quot;the Service&quot;). This Cookie Policy
                explains how we use cookies and similar technologies when you
                visit our website, mobile application, or interact with any of
                our services (collectively, the &quot;Service&quot;). This
                Cookie Policy should be read alongside our Privacy Policy and
                Terms and Conditions.
              </p>

              <h6>What Are Cookies?</h6>

              <p>
                Cookies are small text files that are stored on your device
                (computer, tablet, or mobile) when you visit certain web pages.
                They are widely used to make websites work more efficiently,
                provide basic functionality such as remembering your
                preferences, and to provide information to the owners of the
                website. Cookies cannot harm your device and do not contain any
                personally identifiable information.
              </p>

              {/* <h4>Information We Collect</h4> */}

              <h6>Types of Cookies We Use</h6>

              <p>We use the following types of cookies:</p>
              <h6>Essential Cookies</h6>
              <p>
                These cookies are necessary for the Service to function
                properly. They enable core functionality such as security,
                network management, and account access. You may not opt-out of
                these cookies as the Service cannot function properly without
                them.
              </p>
              <div className={styles.menudot}>
                <p>Examples include:</p>
                <ul>
                  <li>
                    <p>Session cookies that maintain your logged-in status</p>
                  </li>
                  <li>
                    <p>
                      Security cookies that prevent fraudulent use of accounts
                    </p>
                  </li>
                  <li>
                    <p>Cookies that remember your privacy preferences</p>
                  </li>
                </ul>
                <h6>Functional Cookies</h6>
                <div className={styles.menudot}>
                  <ul>
                    <li>
                      <p>Cookies that remember your profile settings</p>
                    </li>
                    <li>
                      <p>Cookies that remember your search preferences</p>
                    </li>
                    <li>
                      <p>Cookies that customize the content you see</p>
                    </li>
                  </ul>
                </div>
              </div>
              <h6>Performance and Analytics Cookies</h6>
              <p>
                These cookies collect information about how visitors use our
                Service. The information is aggregated and anonymous, and does
                not identify individual users. We use this information to
                improve our Service and understand how users interact with our
                platform.
              </p>
              <p>Examples include:</p>
              <div className={styles.menudot}>
                <ul>
                  <li>
                    <p>Cookies that track which pages are most popular</p>
                  </li>
                  <li>
                    <p>
                      Cookies that analyse how users navigate through the
                      Service
                    </p>
                  </li>
                  <li>
                    <p>
                      Cookies that help us understand if users encounter any
                      errors
                    </p>
                  </li>
                </ul>
              </div>

              <h6>Marketing and Advertising Cookies</h6>
              <p>
                These cookies are used to track visitors across websites and to
                display advertisements that are relevant and engaging for the
                individual user. They are usually placed by advertising networks
                with our permission.
              </p>
              <p>Examples include:</p>
              <div className={styles.menudot}>
                <ul>
                  <li>
                    <p>
                      Cookies used to show you relevant matrimony advertisements
                    </p>
                  </li>
                  <li>
                    <p>
                      Cookies used to limit the number of times you see an
                      advertisement
                    </p>
                  </li>
                  <li>
                    <p>
                      Cookies used to measure the effectiveness of advertising
                      campaigns
                    </p>
                  </li>
                </ul>
              </div>

              <h6>Third-Party Cookies</h6>
              <p>
                Some cookies are placed by third parties on our behalf. These
                third parties may include:
              </p>
              <div className={styles.menudot}>
                <ul>
                  <li>
                    <p>Analytics providers (such as Google Analytics)</p>
                  </li>
                  <li>
                    <p>Advertising networks</p>
                  </li>
                  <li>
                    <p>Social media platforms</p>
                  </li>
                  <li>
                    <p>Payment processors</p>
                  </li>
                </ul>
              </div>
              <p>
                Each third party uses cookies for different purposes. We
                encourage you to review the cookie policies of these third
                parties for more information.
              </p>

              <h6>Cookie Management</h6>
              <p>
                Most web browsers allow you to manage your cookie preferences.
                You can:
              </p>
              <div className={styles.menudot}>
                <ul>
                  <li>
                    <p>Delete cookies from your device</p>
                  </li>
                  <li>
                    <p>
                      Block cookies by activating the setting on your browser
                      that allows you to refuse all or some cookies
                    </p>
                  </li>
                  <li>
                    <p>
                      Set your browser to notify you when you receive a cookie
                    </p>
                  </li>
                </ul>
              </div>
              <p>
                Please note that if you choose to block or delete cookies, you
                may not be able to access certain areas or features of our
                Service, and some functionality may be impaired.
              </p>

              <h6>Instructions for Managing Cookies in Popular Browsers:</h6>
              <div className={styles.menudot}>
                <ul>
                  <li>
                    <p>
                      <a
                        href="https://support.google.com/chrome/answer/95647?hl=en-GB"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Google Chrome
                      </a>
                    </p>
                  </li>
                  <li>
                    <p>
                      <a
                        href="https://support.mozilla.org/en-US/kb/delete-browsing-search-download-history-firefox?redirectlocale=en-US&amp;redirectslug=Clear+Recent+History"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Mozilla Firefox
                      </a>
                    </p>
                  </li>
                  <li>
                    <p>
                      <a
                        href="https://support.microsoft.com/en-us/topic/how-to-delete-cookie-files-in-internet-explorer-bca9446f-d873-78de-77ba-d42645fa52fc"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Microsoft Internet Explorerx
                      </a>
                    </p>
                  </li>
                  <li>
                    <p>
                      <a
                        href="https://support.apple.com/en-in/guide/safari/sfri11471/mac"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Apple Safari
                      </a>
                    </p>
                  </li>
                  <li>
                    <p>
                      <a
                        href="https://support.microsoft.com/en-us/microsoft-edge/clear-cookies-and-site-data-in-microsoft-edge"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Microsoft Edge
                      </a>
                    </p>
                  </li>
                </ul>
              </div>

              <h6>Mobile Applications</h6>
              <p>
                For mobile applications, cookie preferences may be managed
                through the app settings or device settings. Please refer to
                your specific device’s instructions for more details.
              </p>
              <h6>Do Not Track</h6>
              <p>
                Some browsers have a &quot;Do Not Track&quot; feature that
                signals to websites that you visit that you do not want to have
                your online activity tracked. Our Service does not currently
                respond to &quot;Do Not Track&quot; signals.
              </p>
              <h6>Compliance with Indian Law</h6>
              <p>
                This Cookie Policy is designed to comply with Indian laws and
                regulations, including the Information Technology Act, 2000, and
                its associated rules. We are committed to ensuring our cookie
                practices respect your privacy in accordance with Indian legal
                requirements.
              </p>
              <h6>Changes to This Cookie Policy</h6>
              <p>
                We may update this Cookie Policy from time to time to reflect
                changes in technology, regulation, or our business practices.
                Any changes will be posted on this page with an updated revision
                date. We encourage you to review this Cookie Policy periodically
                for any changes.
              </p>
              <h6>Contact Us</h6>
              <p>
                If you have any questions about our use of cookies or this
                Cookie Policy, please contact us at:
              </p>

              <ul>
                <li>
                  <p>
                    <b>Email:</b>
                    <a
                      href="mailto:info@samskrutimatrimony.com"
                      style={{ marginLeft: '4px' }}
                    >
                      info@samskrutimatrimony.com
                    </a>
                  </p>
                </li>
                {/* <li>
                  <p>
                    <b>Postal Address:</b> Hyderabad
                  </p>
                </li> */}
                {/* <b>Postal Address:</b> Villa: 217, S T B L, Lakshmi Manohara
                    Gardens, Duvvada, Visakhapatnam, Visakhapatnam - 530046,
                    Andhra Pradesh */}
                {/* <li>
                  <p>
                    <b>Phone:</b> +91 XXXXXXXXXX
                  </p>
                </li> */}
              </ul>
              <p>You may also contact our Grievance Officer:</p>
              <ul>
                {/* <li>
                  <p>
                    <b>Name:</b> Lakshminarayana Muppalla
                  </p>
                </li> */}
                <li>
                  <p>
                    <b>Email:</b>
                    <a
                      href="mailto:info@samskrutimatrimony.com"
                      style={{ marginLeft: '4px' }}
                    >
                      info@samskrutimatrimony.com
                    </a>
                  </p>
                </li>
                {/* <li>
                  <p>
                    <b>Address:</b> Hyderabad
                  </p>
                </li> */}
                {/* <b>Address:</b> Villa: 217, S T B L, Lakshmi Manohara
                    Gardens, Duvvada, Visakhapatnam, Visakhapatnam- 530046,
                    Andhra Pradesh */}
                {/* <li>
                  <p>
                    <b>Phone:</b> +91 XXXXXXXXXX
                  </p>
                </li> */}
              </ul>
              <p>
                <b>Last Updated</b>: 10th March 2025
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cookie;
